import React from 'react';

import { Box } from '@mui/material';

interface Props {
  children: React.ReactNode;
}

export default function RelatedTileGrid({ children }: Props) {
  return (
    <Box
      sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', xl: 'repeat(3, 1fr)' } }}
    >
      {children}
    </Box>
  );
}
